/**
 * @generated SignedSource<<f75df239ca47a11de74b147125f72ef6>>
 * @relayHash 16f3882ad6993ed1dbb0699618403b63
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0a5f8cb7da516bfddd630dc79d08fc70805d96a19d3c7d76ff35de20f0231fd1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { IssueTransitionModalQuery } from './IssueTransitionModalQuery.graphql';

import enableUiModificationsForItAgentView_provider from '@atlassian/jira-relay-provider/src/enable-ui-modifications-for-it-agent-view.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';

const node: PreloadableConcreteRequest<IssueTransitionModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0a5f8cb7da516bfddd630dc79d08fc70805d96a19d3c7d76ff35de20f0231fd1",
    "metadata": {},
    "name": "IssueTransitionModalQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcenableuimodificationsforitagentviewrelayprovider": enableUiModificationsForItAgentView_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider
    }
  }
};

export default node;
